import React, { useState, useEffect } from "react";
import "./index.scss";
import { Button, Modal, Toast } from "antd-mobile";
import { useHistory } from "react-router-dom";
import walletImg from "@/assets/images/wallet.png";
import checkboxImg from "@/assets/images/checkbox.png";
import { createNonceStr, md5, getLocationSearch } from "@/utils/utils";
import request from "@/utils/request";
import { freeCardList, freeCardBuy, accountBalance } from "@/api";

const FreeCommissionCard = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true); // 添加loading状态
  const [list, setList] = useState([]);
  const [walletInfo, setWalletInfo] = useState({
    balance: 0,
  });
  const [oneCard, setOneCard] = useState({});
  const [isBalanceSufficient, setIsBalanceSufficient] = useState(false);
  let token = getLocationSearch().token;
  let appKey = "app_h5";
  let secret = "11dc72cf-88b0-46cd-91d7-b1a77fd69ee1";
  let timestamp = new Date().getTime();
  let random = createNonceStr();
  let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
  let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
  const params = {
    appKey: appKey,
    timestamp: timestamp,
    random: random,
    token: token,
    sign: sign,
  };
  const [visible, setVisible] = useState(false);
  const pay = async () => {
    Toast.loading("支付中...", 0, () => {}, true);
    const res = await request.post(
      `${freeCardBuy}${oneCard.freeCardId}`,
      { token },
      params
    );
    Toast.hide();
    if (res.data.errorCode == 0) {
      Toast.success("支付成功");
      setVisible(false);
      getAccountBalance();
      getFreeCardList();
    } else if (res.data.errorMsg) {
      Toast.fail(res.data.errorMsg, 2);
    }
  };
  const toDetail = (item) => () => {
    if (item.status !== 1) {
      return;
    }
    history.push(
      `/freeCommissionCardDetail/${item.id}?cardData=${JSON.stringify(
        item
      )}&walletInfo=${JSON.stringify(walletInfo)}`
    );
  };
  const toMy = () => {
    history.push(`/freeCommissionCardMy`);
  };
  const openPay = (e, item) => {
    e.stopPropagation();
    setOneCard(item);
    setIsBalanceSufficient(
      walletInfo.balance >= +(+item.sellPrice * 100).toFixed(0)
    );
    setVisible(true);
  };
  const getFreeCardList = async () => {
    setLoading(true); // 开始加载
    Toast.loading("loading...", 0, () => {}, true);
    const res = await request.post(freeCardList, { token }, params);
    Toast.hide();
    if (res.data.data) {
      setList(res.data.data || []);
    } else if (res.data.errorMsg) {
      Toast.offline(res.data.errorMsg);
    }
    setLoading(false); // 加载完成
  };
  const getAccountBalance = async () => {
    const res = await request.get(accountBalance, { token }, params);
    if (res.data.data) {
      setWalletInfo({
        balance: res.data.data.balance,
      });
    } else if (res.data.errorMsg) {
      Toast.offline(res.data.errorMsg);
    }
  };
  useEffect(() => {
    getFreeCardList();
    getAccountBalance();
    document.title = "免佣卡";
  }, []);
  return (
    <div className="free-commission-card">
      {!loading && ( // 只在非loading状态下显示内容
        <>
          <Modal
            visible={visible}
            popup
            closable
            transparent
            onClose={() => setVisible(false)}
            animationType="slide-up"
            title="购买免佣卡"
          >
            <div className="modal_content">
              <div className="price">
                {oneCard.sellPrice}
                <div className="unit">元</div>
              </div>
              <div className="wallet_info">
                <div className="left">
                  <img src={walletImg}></img>钱包余额支付
                  <div className="wallet_info_tips">
                    （钱包余额：{(walletInfo.balance / 100).toFixed(2)}元）
                  </div>
                </div>
                <div className="right">
                  <img src={checkboxImg}></img>
                </div>
              </div>
              <div
                className="wallet_info_error_tips"
                style={{ display: isBalanceSufficient ? "none" : "block" }}
              >
                余额不足，您可先跑单待钱包余额充足再来购买
              </div>
              <div className="btn_box">
                <Button
                  className="btn"
                  type="warning"
                  onClick={pay}
                  disabled={!isBalanceSufficient}
                >
                  立即购买
                </Button>
              </div>
            </div>
          </Modal>
          <div className="title">
            <div>今日奖励活动</div>
            <div onClick={toMy}>查看已购买</div>
          </div>
          <div className="list">
            {list.length === 0 ? (
              <div className="empty-state">暂无数据</div>
            ) : (
              list.map((item, index) => (
                <div
                  className={`card ${item.status !== 1 ||item.buy ? "card_gray_filter" : ""}`}
                  onClick={toDetail(item)}
                  key={item.freeCardId}
                >
                  <div className="tips">
                    <div className="name">免佣卡-{item.cardName}</div>
                    <div className="date">售卖截止日期：{item.sellEndTime}</div>
                  </div>
                  <div className="card_type">
                    <div className="label">免佣日期</div>
                    <div className="value">
                      {item.freeEndDate ? `${item.freeDate} ~ ${item.freeEndDate}` : item.freeDate}
                    </div>
                  </div>
                  {item.buy  ? (
                    <div className="status_tag">已购买</div>
                  ) : item.status === 0 ? (
                    <div className="status_tag">待开售</div>
                  ) : item.status === 2 ? (
                    <div className="status_tag">已结束</div>
                  ) : item.status === 3 ? (
                    <div className="status_tag">已取消</div>
                  ) : null}
                  <div className="content">
                    <div className="price">￥{item.sellPrice}</div>
                    <div className="progress-bar">
                      <div
                        className="progress"
                        style={{
                          width: `${
                            (item.remainderQuantity / item.sellQuantity) * 100
                          }%`,
                        }}
                      ></div>
                    </div>
                    <div className="progress-tips">
                      仅剩{item.remainderQuantity}/{item.sellQuantity}
                    </div>
                  </div>
                  <hr />
                  <div className="info">
                    <div className="info_content">
                      免佣时段：{item.freeTimeSlot}
                    </div>
                    {/* <div className="right">
                    {item.status === 1 ? (
                      <Button className="btn" type="warning" onClick={(e) => openPay(e, item)} disabled={item.remainderQuantity === 0}>
                        立即购买
                      </Button>
                    ) : item.status === 0 ? (
                      <div className="status-label">待开售</div>
                    ) : item.status === 2 ? (
                      <div className="status-label">已结束</div>
                    ) : item.status === 3 ? (
                      <div className="status-label">已取消</div>
                    ) : null}
                  </div> */}
                  </div>
                </div>
              ))
            )}
          </div>
        </>
      )}
    </div>
  );
};
export default FreeCommissionCard;
